import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Cache } from 'aws-amplify';
import { isRetailPortal, isRetailPortalPathAllowed } from '../_config/portal-view';

@Injectable({
	providedIn: 'root'
})
export class PortalViewGuardService implements CanActivate, CanActivateChild {

	constructor(private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const userAttr = Cache.getItem('userAttr');
		if (isRetailPortal(userAttr) && !isRetailPortalPathAllowed(state.url)) {
			this.router.navigate(['/dashboard']);
			return false;
		}
		return true;
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.canActivate(route, state);
	}
}
